<template>
  <div class="ReplenishmentSend">
    <OrderListCommon :status="status" @listt="listt" :urlT="urlT"></OrderListCommon> 
  </div>
</template>
 
<script>
import OrderListCommon from "../common/ParticularListCommon";
export default {
  created() {
    //
     this.$emit("Active", 0);   
  },
  data() {
    return {
      status: 10, //补货单状态
      sendList: [], //补货单列表
      customerId: "", //客户ID
      urlT: "/SendDetails"
    };
  },
  methods: {
    listt(listt) {
      this.sendList = listt;
      this.$emit("list", this.sendList);
    }
  },
  components: {
    OrderListCommon
  }
};
</script>

<style scoped>
.ReplenishmentSend{
  height: 100%;
}
</style>